import { useState } from 'react'

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'

interface EducationProps {
  user_education:
    | {
        level: string | undefined
        school: string | undefined
        major: string | undefined
        start_date: string | undefined
        graduation_date: string | null | undefined
      }[]
    | undefined
}
export function Education(props: EducationProps) {
  const { user_education } = props
  const [show, setShow] = useState<boolean>(true)
  const idAccordion = 'education'
  return (
    <>
      <Accordion
        defaultValue={idAccordion}
        type="single"
        collapsible
        className="w-full rounded-md border-t-4 border-t-[#D91F2E] bg-white"
        onValueChange={(value) => setShow(value === idAccordion)}
      >
        <AccordionItem value={idAccordion} className="border-none p-0">
          <AccordionTrigger className="border-b border-b-[#EAECF0] p-6">
            <div className="flex w-full items-center justify-between">
              <div>Pendidikan</div>
              <div className="text-xs">{show ? 'Sembunyikan' : ''}</div>
            </div>
          </AccordionTrigger>
          <AccordionContent className="w-full">
            {user_education?.length == 0 ? (
              <div className="flex justify-center p-4">Tidak ada data</div>
            ) : (
              <></>
            )}
            <div className="flex w-full flex-col gap-6 divide-y">
              {user_education?.map((education) => (
                <div className="grid w-full grid-cols-4 gap-4 gap-y-6 p-6">
                  <div className="flex flex-col">
                    <div className="font-semibold">Tingkat Pendidikan</div>
                    <div>{education.level}</div>
                  </div>
                  <div className="flex flex-col">
                    <div className="font-semibold">Nama Kampus</div>
                    <div>{education.school}</div>
                  </div>
                  <div className="flex flex-col">
                    <div className="font-semibold">Bidang Studi</div>
                    <div>{education.major}</div>
                  </div>
                  <div className="flex flex-col">
                    <div className="font-semibold">Tanggal Mulai - Lulus</div>
                    <div>
                      {`${education.start_date} - ${education.graduation_date}`}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </>
  )
}
